import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "stop_cancel",
  class: "box_sso stop_cancel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoutPendingModal = _resolveComponent("LogoutPendingModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_LogoutPendingModal, {
      "applied-at": $options.cancelAppliedAt,
      "finished-at": $options.cancelFinishedAt,
      "remaining-text": $options.cancelRemainingText,
      loading: $data.request.intercept.submit,
      onRestore: $options.submit,
      onContinue: $options.backLogin
    }, null, 8 /* PROPS */, ["applied-at", "finished-at", "remaining-text", "loading", "onRestore", "onContinue"])
  ]))
}